import { all, call, put, takeEvery } from 'redux-saga/effects';

import * as actions from '@actions/vatNumbers';
import { getFilingTypes, getVatNumbers } from '@api/vatNumbers';
import types from '@constants/action-types';

export const handleGetVatNumbersRequest = function* ({ payload }) {
  try {
    const response = yield call(getVatNumbers, payload);

    if (response.isAxiosError) return yield put(actions.getVatNumbersFailure(response.message));
    yield put(actions.getVatNumbersSuccess(response));
  } catch (e) {
    yield put(actions.getVatNumbersFailure(e));
  }
};

export const handleGetFilingTypesRequest = function* ({ payload }) {
  try {
    const response = yield call(getFilingTypes, payload);
    if (response.isAxiosError) return yield put(actions.getFilingTypesFailure(response.message));
    yield put(actions.getFilingTypesSuccess(response));
  } catch (e) {
    yield put(actions.getFilingTypesFailure(e));
  }
};

export default all([
  takeEvery(types.GET_VAT_NUMBERS_REQUEST, handleGetVatNumbersRequest),
  takeEvery(types.GET_FILING_TYPES_REQUEST, handleGetFilingTypesRequest),
]);
